// File for logic corresponding to header component
import { Component } from 'js-component-framework';
import breakpoints from '@/js/utils/breakpoints';
import './post-list.scss';

// Import Swiper mobile and styles
import Swiper, { A11y } from 'swiper';
import 'swiper/css';
import 'swiper/css/a11y';

/**
 * Component for post list
 */
export default class PostList extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Only initialize mobile sliders on mobile.
    if (breakpoints.smMax.matches) {
      this.initMobileSliders();
    }
  }

  /**
   * Initialize Mobile Sliders
   * @returns void
   */
  initMobileSliders() {
    const { postMobileSliders } = this.children;

    if (!postMobileSliders) {
      // No mobile sliders in post list.
      return;
    }

    postMobileSliders.forEach((slider) => {
      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper(
        slider,
        {
          wrapperClass: 'post-list__content',
          slideClass: 'post-list__item',
          slidesPerView: 1.25,
          modules: [A11y],
        },
      );
    });
  }
}
